import React from "react";

export default function Marquee({ items, className = "" }) {
  const list = [...items, ...items];
  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`} data-testid="marquee">
      <div className="marquee-track">
        {list.map((it, i) => (
          <span key={i} className="marquee-item inline-flex items-center gap-6 serif italic text-4xl md:text-6xl">
            {it}
            <span className="w-2 h-2 rounded-full bg-[#b8892b] inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
